import { take, call, put, fork } from 'redux-saga/effects';
import {
  registUser,
  failRegistUser,
  successRegistUser,
  checkEmail,
  failCheckEmail,
  successCheckEmail,
  reminderEmail,
  successGetData,
} from '../actions/regist';
import { fetchLoginState } from '../actions/auth';
import superFetch from '../modules/superFetch';
import { push } from 'connected-react-router';

// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleRegistUser() {
  while (true) {
    const action = yield take(`${registUser}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/regist/regist',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      yield put(successRegistUser(payload));
      const jwt = payload.jwt;
      yield localStorage.setItem('jwt', jwt);
      yield put(successRegistUser(payload));
      yield put(fetchLoginState());
      continue;
    }

    if (!payload && err) {
      yield put(failRegistUser(String(err)));
      continue;
    }
  }
}

export function* handleCheckEmail() {
  while (true) {
    const action = yield take(`${checkEmail}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/regist/checkemail/',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      yield put(successCheckEmail(payload));
      yield put(push('/regist/authcode'));
      continue;
    }

    if (!payload && err) {
      yield put(failCheckEmail(String(err)));
      continue;
    }
  }
}
export function* handleReminderEmail() {
  while (true) {
    const action = yield take(`${reminderEmail}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/regist/reminderemail',
      data: { email: action.payload.email },
      type: 'POST',
    });

    if (payload && !err) {
      yield put(successGetData(payload));

      yield put(push('/regist/reminder/authcode'));
      continue;
    }

    if (!payload && err) {
      yield put(failCheckEmail(String(err)));
      continue;
    }
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleRegistUser);
  yield fork(handleCheckEmail);
  yield fork(handleReminderEmail);
}



// WEBPACK FOOTER //
// ./src/sagas/regist.js